var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcBtnNext = function SvgIcBtnNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47 15.03a.75.75 0 0 1 0-1.06l5.92-5.92-5.92-5.92a.75.75 0 0 1 1.06-1.06l6.45 6.45a.75.75 0 0 1 0 1.06l-6.45 6.45a.75.75 0 0 1-1.06 0Z"
  })));
};
export default SvgIcBtnNext;